import { render, staticRenderFns } from "./game-calculation.vue?vue&type=template&id=02be6371&scoped=true"
import script from "./game-calculation.vue?vue&type=script&lang=js"
export * from "./game-calculation.vue?vue&type=script&lang=js"
import style0 from "./game-calculation.vue?vue&type=style&index=0&id=02be6371&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02be6371",
  null
  
)

export default component.exports